import { Component, OnInit } from '@angular/core';
import { ToggleNewSearchService } from '@shared/services/toggle-new-search/toggle-new-search.service';
import { firstValueFrom, Observable } from 'rxjs';
import { SearchAnalyticsService } from '@search/services/search-analytics.service';

@Component({
  selector: 'app-toggle-new-search',
  templateUrl: './toggle-new-search.component.html',
  styleUrls: ['./toggle-new-search.component.scss'],
})
export class ToggleNewSearchComponent implements OnInit {
  toggleIsOn: Observable<boolean>;
  private readonly COVEO_BUTTON_NAME = 'toggle to coveo';
  private readonly ENDECA_BUTTON_NAME = 'toggle to endeca';

  constructor(
    private toggleNewSearchService: ToggleNewSearchService,
    private searchAnalyticsService: SearchAnalyticsService,
  ) {}

  ngOnInit() {
    this.toggleIsOn = this.toggleNewSearchService.isNewSearchEnabled();
  }

  setToggle() {
    this.toggleNewSearchService.toggle();
    this.trackToggleClickEvent();
  }

  async trackToggleClickEvent() {
    const isToggleOn = await firstValueFrom(this.toggleIsOn);
    this.searchAnalyticsService.trackSearchToggleEvent(
      isToggleOn ? this.COVEO_BUTTON_NAME : this.ENDECA_BUTTON_NAME,
    );
  }
}
